import { all, fork, put, select, take } from 'redux-saga/effects';


export function gaFormat(str) {
    return str.replace(' ', '-').replace(/(\b\w)/g, (m) => m.toUpperCase());
}

export function* watchPick() {
    while (true) {
        const { payload: { source } } = yield take('tarot-reading:picked');
        const pickedCards = yield select(state => state['tarot-reading'].cards);
        let positions = yield select(state => state['tarot-reading'].positions);

        // timing issues with the upsell
        if (pickedCards.length > positions.length) {
            yield take('tarot-reading:positions');
            positions = yield select(state => state['tarot-reading'].positions);
        }

        const cardPosition = positions[pickedCards.length - 1].position;
        yield put({
            type: 'tarot-ga:event',
            payload: `Click-${gaFormat(cardPosition)}-in-${source}`,
        });
    }
}

export function* watchUpsell() {
    while (true) {
        yield take('tarot-reading:upsell');
        yield put({ type: 'tarot-ga:event', payload: 'Click-Upsell-Deck' });
    }
}

export function* watchReveal() {
    while (true) {
        yield take('tarot-reading:fetch');

        let action = 'Click-Thru-to-Checkout';

        const upc = yield select(state => state.product.teeup.code);
        const type = yield select(state => state['tarot-reading'].type);

        if (/sample/.test(upc) && !type) {
            action = 'Click-Thru-to-Interp';
            yield put({
                type: 'promo-tracker:recordInternal',
                payload: ['Tarot Reading Module', upc],
            });
        }

        yield put({ type: 'tarot-ga:event', payload: action });
    }
}

export function* watchGaEvent() {
    while (true) {
        const { payload } = yield take('tarot-ga:event');
        const upc = yield select(state => state.product.teeup.code);
        yield put({ type: 'ga:event', payload: ['Tarot Readings', payload, upc] });
    }
}

export function* root() {
    yield all([
        fork(watchPick),
        fork(watchUpsell),
        fork(watchReveal),
        fork(watchGaEvent),
    ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tarot-ga.js